import StoreRoot from './stores/root';
import App from './components';

function createStoreRoot(options = {}) {
  return new StoreRoot(options);
}

export { createStoreRoot as createYluiStore };
export { App as Ylui };
